var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMarkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05381 12.242L18.6951 0.545189C19.0568 0.181729 19.5172 0 20.0762 0C20.6353 0 21.0957 0.181729 21.4574 0.545189C21.8191 0.908648 22 1.37123 22 1.93294C22 2.49465 21.8191 2.95724 21.4574 3.3207L8.43498 16.4052C8.04036 16.8017 7.57997 17 7.05381 17C6.52765 17 6.06726 16.8017 5.67265 16.4052L0.5426 11.2507C0.180866 10.8873 0 10.4247 0 9.86297C0 9.30126 0.180866 8.83868 0.5426 8.47522C0.904334 8.11176 1.36472 7.93003 1.92377 7.93003C2.48281 7.93003 2.9432 8.11176 3.30493 8.47522L7.05381 12.242Z",
    fill: "#EBFAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkWhite);
export default __webpack_public_path__ + "static/media/check_mark_white.3619bb19db6e5e88151660ee7dac102a.svg";
export { ForwardRef as ReactComponent };